import { StateCreator } from 'zustand';
import type { ConsentSnapshot } from '@ecom/storefront-consent/models/consent';

export type ConsentState = ConsentSnapshot;

export interface ConsentActions {
  setConsent: (snapshot: ConsentSnapshot) => void;
}

export interface ConsentSlice {
  consent: ConsentState;
  consentActions: ConsentActions;
}

export const createConsentSlice: StateCreator<ConsentSlice> = (set) => ({
  consent: {
    ready: false,
    framework: 'Unknown',
    activeGroups: [],
  },
  consentActions: {
    setConsent: (snapshot) => set({ consent: snapshot }),
  },
});
